import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Box,
  Divider,
  Typography,
  MenuItem,
  Snackbar,
  Alert,Switch,FormControlLabel,
} from '@mui/material';
import { callApi } from '../../../utils/apiClient';
import { Warehouse_API_ENDPOINTS } from '../../../config/api/apiCallWarehouse';
import ObjectTypeActionMenu from './ObjectTypeActionMenu';
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddUpdateWarehouseObjectTypeSize = ({
  formData,
  setFormData,
  setIsFormOpen,
  LoadObjectTypeList,
  handleBackWinderMachineEntry
}) => {
  const [isEdit, setIsEdit] = useState(!!formData.object_id);
  const [objectUnits] = useState(['CM', 'INCH', 'MM']);

  // Snackbar alert
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('warning');

  const showAlert = (msg, severity = 'warning') => {
    setAlertMessage(msg);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleChange = (field, value) => {
  // Convert only string values (non-numeric) to uppercase
  const transformedValue =
    typeof value === 'string' ? value.toUpperCase() : value;

  setFormData((prev) => ({
    ...prev,
    [field]: transformedValue,
  }));
};

  // ✅ CLEAR FUNCTION — resets fields & switches to new entry mode
  const handleClear = () => {
    setFormData({
      object_id: null,
      object_type: '',
      object_length: '',
      object_width: '',
      object_height: '',
      object_unit: '',
    });
    setIsEdit(false);
    showAlert('Form cleared. Ready for new entry.', 'info');
  };

  const validateFields = () => {
    if (!formData.object_type?.trim()) {
      showAlert('Object Type is required.');
      return false;
    }
    if (!formData.object_length || isNaN(formData.object_length) || formData.object_length <= 0) {
      showAlert('Object Length must be a valid positive number.');
      return false;
    }
    if (!formData.object_width || isNaN(formData.object_width) || formData.object_width <= 0) {
      showAlert('Object Width must be a valid positive number.');
      return false;
    }
    if (!formData.object_height || isNaN(formData.object_height) || formData.object_height <= 0) {
      showAlert('Object Height must be a valid positive number.');
      return false;
    }
    if (!formData.object_unit) {
      showAlert('Object Unit selection is required.');
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    const payload = {
      p_object_id: formData.object_id || 0,
      p_object_type: formData.object_type.trim(),
      p_object_length: parseFloat(formData.object_length),
      p_object_width: parseFloat(formData.object_width),
      p_object_height: parseFloat(formData.object_height),
      p_object_unit: formData.object_unit,
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
      p_created_by: localStorage.getItem('userID'),
      p_updated_by: localStorage.getItem('userID'),
      p_status: formData.status ? 'true' : 'false',
    };

    const endpoint = isEdit
      ? Warehouse_API_ENDPOINTS.objectType.update
      : Warehouse_API_ENDPOINTS.objectType.create;

    try {
      const response = await callApi(endpoint, 'POST', { 'Content-Type': 'application/json' }, payload);
    
       // ✅ Get the message from the API response
  const message =
   response[0]?.message ||       // fallback if API returns plain object
    "Object Type updated successfully!";
  // ✅ Success message
      toast.success(
       message,
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2000 }
      );
  
      // ✅ Reload list and find the newly created record
       LoadObjectTypeList();
  
      if (!isEdit && response && response[0]?.object_id) {
            setFormData({
              object_id: response[0].object_id,
              code: formData.code,
              description: formData.description,
              status: formData.status,
            });
          } else {
            // For updates, just ensure data stays in edit mode
            setFormData((prev) => ({
              ...prev,
              object_id: formData.object_id,
            }));
            setIsEdit(true); // stay in edit mode after create
          }
      
        } catch (error) {
          console.error('Error saving Object type:', error);
          const errorMsg =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to save Warehouse Type";
              toast.error(errorMsg, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
          // toast.error("Failed to save Object Type", {
          //   position: toast.POSITION.BOTTOM_CENTER,
          //   autoClose: 3000,
          });
        }
      };
  
  

  const handleDelete = async () => {
    if (!isEdit) return;

    const payload = {
      p_object_id: formData.object_id,
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
      p_updated_by: localStorage.getItem('userID'),
    };

    try {
      const response = await callApi(
        Warehouse_API_ENDPOINTS.objectType.delete,
        'POST',
        { 'Content-Type': 'application/json' },
        payload
      );
    
  //showAlert('Record deleted successfully.', 'success');
  toast.success("Object Type deleted successfully!", 
  { position: toast.POSITION.BOTTOM_CENTER }, 
  { autoClose: 2000 }
);
  LoadObjectTypeList();
   setFormData({
      object_id: null,
      object_type: '',
      object_length: '',
      object_width: '',
      object_height: '',
      object_unit: '',
    });
    setIsEdit(false);
      //setIsFormOpen(false);
  
    } catch (error) {
      console.error('Error deleting record:', error);
      showAlert('Error occurred while deleting record.', 'error');
    }
  };

  const handleExit = () => {
  
    setIsFormOpen(false);
  
};

  return (
    <Box fullWidth>
      {/* 🔹 Header / Action Menu */}
      <ObjectTypeActionMenu
        isEdit={isEdit}
        onSave={handleSave}
        onDelete={handleDelete}
        onClear={handleClear}
        onExit={handleExit}
        onSetEditMode={setIsEdit}
        saveDisabled={
          !formData.object_type ||
          !formData.object_length ||
          !formData.object_width ||
          !formData.object_height ||
          !formData.object_unit
        }
      />

      <Divider />

      {/* 🔹 Form Section */}
      <Box p={3}>
        <Grid container spacing={3}>
          {/* Object Type */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={{ xs: '20px', sm: '10px' }} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Object Type<span style={{ color: 'red' }}> *</span>
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Object Type"
                  value={formData.object_type || ''}
                  onChange={(e) => handleChange('object_type', e.target.value)}
                  inputProps={{ style: { color: '#fff' } }}
                   disabled={isEdit}
                />
              </Box>
            </Box>
          </Grid>

          {/* Object Length */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={{ xs: '20px', sm: '10px' }} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Object Length<span style={{ color: 'red' }}> *</span>
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  type="number"
                  inputProps={{ min: 0, step: 'any', style: { color: '#fff' } }}
                  placeholder="Enter Object Length"
                  value={formData.object_length || ''}
                  onChange={(e) => handleChange('object_length', e.target.value)}
                />
              </Box>
            </Box>
          </Grid>

          {/* Object Width */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={{ xs: '20px', sm: '10px' }} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Object Width<span style={{ color: 'red' }}> *</span>
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  type="number"
                  inputProps={{ min: 0, step: 'any', style: { color: '#fff' } }}
                  placeholder="Enter Object Width"
                  value={formData.object_width || ''}
                  onChange={(e) => handleChange('object_width', e.target.value)}
                />
              </Box>
            </Box>
          </Grid>

          {/* Object Height */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={{ xs: '20px', sm: '10px' }} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Object Height<span style={{ color: 'red' }}> *</span>
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  type="number"
                  inputProps={{ min: 0, step: 'any', style: { color: '#fff' } }}
                  placeholder="Enter Object Height"
                  value={formData.object_height || ''}
                  onChange={(e) => handleChange('object_height', e.target.value)}
                />
              </Box>
            </Box>
          </Grid>

          {/* Object Unit */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={{ xs: '20px', sm: '10px' }} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Object Unit<span style={{ color: 'red' }}> *</span>
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  select
                  fullWidth
                  size="small"
                  color="secondary"
                  value={formData.object_unit || ''}
                  onChange={(e) => handleChange('object_unit', e.target.value)}
                  inputProps={{ style: { color: '#fff' } }}
                >
                  {objectUnits.map((unit) => (
                    <MenuItem key={unit} value={unit}>
                      {unit}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Box>
          </Grid>
 {/* ✅ Status (Active / Inactive Switch) */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={2} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Status
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#fff' }}>
  <Switch
    checked={formData.status === undefined ? true : formData.status}
    color="secondary"
    onChange={(e) =>
      setFormData({
        ...formData,
        status: e.target.checked,
      })
    }
  />
  <Typography sx={{ ml: 1 }}>
    {formData.status === undefined
      ? "Active"
      : formData.status
      ? "Active"
      : "Inactive"}
  </Typography>
</Box>

              </Box>
            </Box>
          </Grid>

        </Grid>
      </Box>

      {/* Snackbar Alert */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={() => setAlertOpen(false)}
        
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddUpdateWarehouseObjectTypeSize;
